<template>
  <header class="section-header">{{ title }}</header>
</template>

<script>
export default {
  props: {
    title: String
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_colors.scss";

.section-header {
  margin-bottom: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid $dirtyWhite;
  color: $mutedGray;
  font-weight: bold;
  line-height: 1;
}
</style>

